module.exports = __webpack_public_path__ + "static/media/xk.49e9e8c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/xk.svg
// module id = 1475
// module chunks = 0